export default {
  id: null,
  handle: null,
  title: null,
  nb_colors: 0,
  sizes: [],
  medias: [],
  normalized_color: null,
  sample_color: null,
  internal_color_code: null,
  internal_type: null,
  price: null,
  strikeout_price: null,
  tags: null,
  flaps: [],
  categories: [],
  sku: null,
  intellisuggestData: null,
  intellisuggestSignature: null,
}
